import { AppCommandsManager } from "../../../../../library-js/web-app/commands/AppCommandsManager";
import { WebApp } from "../../../../../library-js/web-app/WebApp";
import { AudioEditor } from "../AudioEditor";
import { AudioEditorProject } from "../project/AudioEditorProject";
import { LoadSound } from "./project/LoadSound";
import { Undo } from "../../../../../library-js/web-app/commands/default-commands/Undo";
import { Redo } from "../../../../../library-js/web-app/commands/default-commands/Redo";
import { SetFullscreen } from "../../rokojori/commands/ToggleFullscreen";
import { Play } from "./audio/Play";
import { SliceClips } from "./export/SliceClips";
import { SaveFiles } from "./_Templates_/SaveFiles";
import { ExportAllClips } from "./export/ExportAllClips";

export class AudioEditorCommandsManager extends AppCommandsManager<AudioEditor,AudioEditorProject>
{
  // PROJECT
  loadSound = new LoadSound( this );

  // EDIT 
  undo = new Undo( this );
  redo = new Redo( this );

  // VIEW
  setFullscreen = new SetFullscreen( this );  

  // AUDIO
  play = new Play( this );

  // EXPORT 
  sliceClips = new SliceClips( this );
  exportAudio = new ExportAllClips( this );
}